import React, { Fragment } from "react"

import {URL_COMPANY, URL_LINKEDIN, URL_INSTAGRAM} from '../../lib/constants'

import InstagramLogo from '../../Img/InstagramIcon.svg'
import LinkedInLogo from '../../Img/LinkedInIcon.svg'

import { GlobalVariable } from '../../Global'

const Footer = ({ isMobileView }) => {
    const goToLink = (e, LinkLocation) => {
        // window.location.href = LinkLocation
        window.open(
            `${LinkLocation}`,
            '_blank'
        )
    }

    const LogoMobile = () => (
        <div
            style={{ border: '0px solid blue', height: '8vh', marginTop: '0' }}
        >
            <div
                style={{ border: '0px solid red', height: '100%' }}
            >
                <img
                    style={{ width: '10%', height: '100%', cursor: 'pointer' }}
                    alt='LinkedInLogo'
                    src={LinkedInLogo}
                    onClick={(e) => goToLink(e, URL_LINKEDIN)}
                />
                <img
                    style={{ width: '10%', height: '100%', cursor: 'pointer', border: '0px solid red' }}
                    alt='InstagramLogo'
                    src={InstagramLogo}
                    onClick={(e) => goToLink(e, URL_INSTAGRAM)}
                />
            </div>
        </div>
    )

    const LogoPC = () => (
        <>
            <div
                style={{ border: '0px solid red', width: '3vw', height: '6vh' }}
            >
                <img
                    style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                    alt='LinkedInLogo'
                    src={LinkedInLogo}
                    onClick={(e) => goToLink(e, URL_LINKEDIN)}
                />
            </div>
            <div
                style={{ border: '0px solid red', width: '3vw', height: '6vh' }}
            >
                <img
                    style={{ width: '100%', height: '100%', cursor: 'pointer', border: '0px solid red' }}
                    alt='InstagramLogo'
                    src={InstagramLogo}
                    onClick={(e) => goToLink(e, URL_INSTAGRAM)}
                />
            </div>
        </>
    )

    return (
        <Fragment>
            <footer
                style={{ backgroundImage: 'linear-gradient(to Left, #90e0ef, #00a3df', border: '0px solid red', bottom: '0px', left: '0px', height: isMobileView ? '20vh' : '8vh', margin: ' 5vh 0 0 0', padding: isMobileView ? '2vh 0 0 0' : '1vh 1vw 1vh 1vw' }}

            >
                <div
                    style={isMobileView ?
                        { margin: 'auto', textAlign: 'center' }
                        : { display: 'flex', alignContent: 'center', justifyContent: 'start', border: '0px solid red', height: '6vh', marginTop: '2vh' }
                    }
                >
                    <div
                        style={{ color: 'white', height: '6vh', margin: isMobileView ? '2vh 0 0 0' : '0 25vw 0 2vw', paddingTop: '1vh', fontFamily: 'Montserrat, Segoe UI', cursor: 'pointer', fontSize: isMobileView ? '90%' : '1.2vw' }}
                        onClick={(e) => goToLink(e, URL_COMPANY)}
                    >
                        © 2025, <b>{GlobalVariable.CompanyNameFull}</b>
                    </div>
                    {isMobileView ? <LogoMobile /> : <LogoPC />}
                </div>
            </footer >
        </Fragment>
    )
}

export default Footer